import { Pill, Row, type Tone } from '@leanin/ui';

export type PillFilterOption = {
  value: string;
  label: string;
  count?: number;
};

type SingleProps = {
  multi?: false;
  value: string;
  onChange: (next: string) => void;
  allowDeselect?: boolean;
};

type MultiProps = {
  multi: true;
  value: ReadonlyArray<string>;
  onChange: (next: string[]) => void;
};

export type PillFilterProps = (SingleProps | MultiProps) & {
  options: ReadonlyArray<PillFilterOption>;
  selectedTone?: Tone;
  tone?: Tone;
};

export function PillFilter(props: PillFilterProps) {
  const { options, selectedTone = 'burgundy', tone = 'neutral' } = props;

  const isSelected = (v: string) =>
    props.multi ? props.value.includes(v) : props.value === v;

  const handleClick = (v: string) => {
    if (props.multi) {
      const next = props.value.includes(v)
        ? props.value.filter((x) => x !== v)
        : [...props.value, v];
      props.onChange(next);
      return;
    }
    if (props.value === v) {
      if (props.allowDeselect) props.onChange('');
      return;
    }
    props.onChange(v);
  };

  return (
    <Row gap="sm" wrap>
      {options.map((opt) => {
        const selected = isSelected(opt.value);
        const label =
          typeof opt.count === 'number' ? `${opt.label} (${opt.count})` : opt.label;
        return (
          <Pill
            key={opt.value}
            size="md"
            tone={selected ? selectedTone : tone}
            selected={selected}
            onClick={() => handleClick(opt.value)}
          >
            {label}
          </Pill>
        );
      })}
    </Row>
  );
}
